import {NOTIFICATIONS} from '@constants/internal-route.constant'
import {IAppRoutes} from '@interface/common.interface'
import {lazy} from 'react'

/**
 * In-app notifications — reached from the topbar bell's "View all", not from the sidebar.
 *
 * Deliberately NOT feature-gated: the feed is already scoped in SQL to the caller's own
 * user_id (plus company-wide broadcasts) for this module only, so every user may open their
 * own notifications. An ACL feature here would only create a way to lock someone out of them.
 */
export const NotificationRoutes: IAppRoutes = {
  link: NOTIFICATIONS,
  element: lazy(() => import('@modules/notification/NotificationList')),
}
